<div>
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button
			id="closeShareUpdateButton"
			mat-icon-button
			(click)="onCloseClick()"
		>
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
			/>
		</button>
	</div>
	<div fxLayout="column" fxFill>
		<div ngClass="m-l-l">
			<h2 i18n="@@button_shareUpdates">Share Update</h2>
		</div>
		<mat-dialog-content fxLayout="column">
			<div style="background-color: #efeef8" ngClass="p-s">
				<h2 i18n="@@share_update_of_title">Share update of {{ this.date }}</h2>
				<p class="mat-typography">{{ this.content }}</p>
			</div>
			<ng-template [ngIf]="isLoggedIn">
				<div
					fxFlex
					fxLayout="row wrap"
					class="draft-bg p-m m-t-l"
					fxLayoutAlign="space-between center"
				>
					<p
						ngClass.gt-md="p-r-xxl p-t-s"
						class="mat-typography"
						i18n="@@shareUpdate_sendUpdateEmail_note"
					>
						Would you like to send email for fundraiser update to all donors?
					</p>
					<button
						mat-flat-button
						[disabled]="disableSendEmail"
						(click)="onSendEmailClick()"
						i18n="@@button_sendEmail"
					>
						Send Email
					</button>
				</div>
				<ng-template [ngIf]="noDonationNote">
					<p i18n="@@no_donation_note" class="mat-typography mat-subtitle-2 p-t-s">
						Note:This functionality is not operational because there are no
						donors registered with this fundraiser.
					</p>
				</ng-template>
			</ng-template>
			<div fxLayout="column" class="draft-bg m-t-l p-m">
				<h2 i18n="@@shareUpdate_socialMedia_title">
					Share updates on social media
				</h2>
				<p i18n="@@shareUpdate_socialMedia_label" class="mat-typography">
					Share fundraiser updates by clicking on the Social media icon below
				</p>
				<div
					fxFlex="100%"
					fxLayout="row wrap"
					fxLayoutAlign="start center"
					fxLayoutAlign.lt-sm="start"
					class="social-share"
					fxLayoutGap.gt-lg="40px"
					fxLayoutGap.lg="40px"
					fxLayoutGap.md="30px"
					fxLayoutGap.sm="50px"
					fxLayoutGap.lt-sm="28px"
				>
					<div class="facebook p-b-xs" ngClass="m-t-xs">
						<button
							id="facebookShareButton"
							mat-icon-button
							shareButton="facebook"
							[disabled]="disableSocialShare"
							[url]="shareLink"
							[description]="messageContent"
						>
							<img
								height="51"
								width="51"
								[src]="
									disableSocialShare
										? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb-disabled/public'
										: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/fb-color/public'
								"
							/>
						</button>
					</div>
					<div class="email p-b-xs" ngClass="m-t-s">
						<button
							id="emailShareButton"
							mat-icon-button
							shareButton="email"
							[disabled]="disableSocialShare"
							[url]="shareLink"
							[description]="messageContent"
						>
							<img
								height="50"
								width="57"
								[src]="
									disableSocialShare
										? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mail-disabled/public'
										: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/mail-color/public'
								"
							/>
						</button>
					</div>
					<div class="twitter p-b-s p-t-xs">
						<button
							id="twitterShareButton"
							mat-icon-button
							shareButton="twitter"
							[disabled]="disableSocialShare"
							[url]="shareLink"
							[description]="messageContent"
						>
							<img
								height="55"
								width="57"
								[src]="
									disableSocialShare
										? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x-disabled/public'
										: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/x/public'
								"
							/>
						</button>
					</div>
					<div class="linkedin p-b-xxs" ngClass.lt-sm="m-t-xs">
						<button
							id="linkedShareButton"
							mat-icon-button
							shareButton="linkedin"
							[disabled]="disableSocialShare"
							[url]="shareLink"
							[description]="messageContent"
						>
							<img
								height="54"
								width="57"
								[src]="
									disableSocialShare
										? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin-disabled/public'
										: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/linkedin-color/public'
								"
							/>
						</button>
					</div>
					<div class="whatsapp p-b-xxs" ngClass.lt-sm="m-t-xs">
						<button
							id="whatsAppShareButton"
							mat-icon-button
							shareButton="whatsapp"
							[disabled]="disableSocialShare"
							[url]="shareLink"
							[description]="messageContent"
						>
							<img
								height="54"
								width="54"
								[src]="
									disableSocialShare
										? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whatsapp-disabled/public'
										: 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whatsapp-color/public'
								"
							/>
						</button>
					</div>
				</div>
			</div>
		</mat-dialog-content>
	</div>
</div>
